import React, { useContext } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';
import { StorePodLoader } from './StorePodLoader';

export const StorePodDistance = () => {
  const { loading, store } = useContext(StorePodContext);

  const { distance } = store;

  if (loading) {
    return (
      <div data-testid="store-pod-distance-loader" data-component="StorePodDistanceLoader">
        <StorePodLoader height="2rem" />
      </div>
    );
  }

  return (
    <div className="sui-font-bold" data-component="StorePodDistance">
      <span className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap">
        <Typography height="tight" weight="bold">{distance} mi</Typography>
      </span>
    </div>
  );
};

StorePodDistance.displayName = 'StorePodDistance';
